import { Component, OnInit, ViewChild } from '@angular/core';
import { FileManagerService } from '../file-manager.service';
import { Observable } from 'rxjs/Observable';
import { fuseAnimations } from '../../../../core/animations';
import { Fichero } from '../../../../core/modelos/fichero';
import { MatTableDataSource, MatDialogRef, MatDialog, MatSort } from '@angular/material';
import { TicketsService } from '../../tickets/tickets.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { PdfModalService } from '../../../../core/pdf-modal/pdf-modal.service';
import { NgxGalleryOptions, NgxGalleryComponent } from 'ngx-gallery';
import { NgxGalleryImage } from 'ngx-gallery';
import { NgxGalleryImageSize } from 'ngx-gallery';
import { NgxGalleryAnimation } from 'ngx-gallery';
import { User } from '../../../../core/modelos/user';
import { NotificacionesService } from '../../../../core/notificaciones/notificaciones.service';
import { ConfirmService } from '../../../../core/components/confirm/confirm.service';
import { Activo } from '../../../../core/modelos/activo';
import { ActivosService } from '../../activos/activos.service';
import { ListaModalComponent } from '../../../../core/components/lista-modal/lista-modal.component';
import { Ticket } from '../../../../core/modelos/ticket';
import { ActivosOcultosService } from '../../../../core/services/activos-ocultos.service';

@Component({
    selector: 'fuse-file-list',
    templateUrl: './file-list.component.html',
    styleUrls: ['./file-list.component.scss'],
    animations: fuseAnimations
})


export class FileListComponent implements OnInit {

    @ViewChild(NgxGalleryComponent) galeria: NgxGalleryComponent;
    @ViewChild(MatSort) sort: MatSort;

    files: any;
    dataSource: MatTableDataSource<Fichero>;
    // displayedColumns = ['icon', 'name', 'version', 'size', 'modified', 'nuevaVersion', 'asociado', 'acciones'];
    displayedColumns = ['icon', 'name', 'acciones', 'version', 'nuevaVersion', 'size', 'modified', 'asociado'];
    selected: any;
    canBack = false;
    activos: Array<Activo>;

    showFile = false;
    ficheros: Array<Fichero>;
    ficheroACopiar: Fichero;

    selectedFiles: FileList;

    qrValue: string;
    documento;
    // Variables nuevas para la visualizacion dentro de la app
    pdf;
    imagen;
    galleryOptions: NgxGalleryOptions[];
    galleryImages: NgxGalleryImage[];
    asociar = false; // Cuando quiera asociar una carpeta a un activo lo pondre a true
    usuarioLogueado: User;
    activo: Activo;

    
    carpetasAWSOcultas = null;

    static categorizarFicheros(data): Array<Fichero> {
        const ficheros = new Array<Fichero>();
        const carpetas = data.CommonPrefixes;
        carpetas.forEach(carpeta => {
            if (carpeta.Prefix !== 'Anexos/') {
                ficheros.push(new Fichero(0, carpeta.Prefix, null, null, null, 'folder'));
            }
        });
        const fileDatas = data.Contents;

        fileDatas.forEach(
            file => {
                let tipoArchivo;
                tipoArchivo = 'folder'; // Si no tiene extension lo tratare como una carpeta
                // Si no es una carpeta, busco su tipo
                const partes = file.Key.split('.');
                switch (partes[partes.length - 1].toLocaleLowerCase()) {
                    case 'docx': tipoArchivo = 'document';
                        break;
                    case 'pdf': tipoArchivo = 'pdf';
                        break;
                    case 'xlsx': tipoArchivo = 'spreadsheet';
                        break;
                    case 'jpg': tipoArchivo = 'image';
                        break;
                    case 'png': tipoArchivo = 'image';
                        break;
                }
                // Añado la condicion file.Size === 0 para distinguir las nuevas carpetas que creo
                if (tipoArchivo && file.Size !== 0) {
                    ficheros.push(new Fichero((file.Size / 1024).toFixed(0), file.Key, file.ETag, file.LastModified, file.StorageClass, tipoArchivo));
                }
            });

        return ficheros;
    }

    constructor(
        public fileManagerService: FileManagerService,
        private ticketsService: TicketsService,
        private router: Router,
        private pdfModalService: PdfModalService,
        private notificaciones: NotificacionesService,
        private confirmService: ConfirmService,
        private activosService: ActivosService,
        private dialog: MatDialog,
        private activosOcultosService: ActivosOcultosService
    ) {
        /*
        this.fileManagerService.onFilesChanged.subscribe(files => {
            if (files && files.length > 0) {
                this.generarRamaSinCarpetasAWSOcultas(files);
            }
        });
        */
    }

    ngOnInit() {
        this.ficheroACopiar = null;
        this.usuarioLogueado = JSON.parse(sessionStorage.getItem('usuarioLogueado')).usuario;
        // const cliente: Cliente = this.fileManagerService.getClienteBucket();
        /* if (this.usuarioLogueado.rol.id === 1 && !cliente) {
            this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.FileManager.ClienteNoEstablecido);
        }
        else { */
        this.showFiles();
        // }
    }
    showFiles() {
        this.reiniciarVariablesDeVisualizacion();
        const component = this;
        // Primero voy a cargar los activos (si estoy en el nivel raiz) y asociaré las carpetas y activos comparando activo.carpetaAWS con el nombre de la carpeta
        // De esa forma, sabre si dicha carpeta tiene algún activo asociado y lo mostraré
        if (this.fileManagerService.carpetaActual == null) {
            localStorage.removeItem('activoSeleccionadoId');
            this.getActivos();
        }
        this.fileManagerService.getFiles().send(function (err, data) {
            if (!err) {
                let ficheros = FileManagerService.categorizarFicheros(data);
                if (ficheros.length === 0) {
                    ficheros = [];
                }
                
                component.generarRamaSinCarpetasAWSOcultas(ficheros);
                
                /*// Los manda a un observable que es recogido en este componente y genera la rama apropiada del arbol
                component.fileManagerService.actualizarFicheros(ficheros);*/
            }
        });
    }

    generarRamaSinCarpetasAWSOcultas(ficherosListados: Fichero[]) {

        if (this.carpetasAWSOcultas) {
            this.generarRama(ficherosListados);
        }
        else {
            this.activosOcultosService.getActivosOcultos(this.usuarioLogueado.id).subscribe(
                data => {
                    if (data.success) {
                        this.carpetasAWSOcultas = data.items.filter(d => d.hidden).map(d => d.activo.carpetaAWS);
                        this.generarRama(ficherosListados);

                        this.fileManagerService.onFilesChanged.subscribe(files => {
                            if (files && files.length > 0) {
                                this.generarRamaSinCarpetasAWSOcultas(files);
                            }
                        });
                        
                    } else {
                        // CONTROLAR ERROR
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Usuarios.ActivosOcultos.SinActivos);
                    }
                },
                err => {
                    // CONTROLAR ERROR
                    this.notificaciones.errorServidor(err.status);
                }
            );
        }
    }

    generarRama(ficherosListados: Fichero[]) {

        this.ficheros = [];
        const carpetas = new Array<string>();

        ficherosListados.forEach(objeto => {

            const partes = objeto.key.split('/');

            if (this.carpetasAWSOcultas.includes(partes[0])) {
                return;
            }

            if (objeto.type === 'folder' && carpetas.indexOf(partes[0]) === -1) {
                // Si el objeto es una carpeta y no lo habia guardado antes
                carpetas.push(partes[partes.length - 2]); // Guardo el nombre de la carpeta
                objeto.name = partes[partes.length - 2]; // Asigno el nombre para el html
                // objeto.name = objeto.key.replace('/', '');
                this.ficheros.push(objeto); // Guardo la carpeta dentro de ficheros, que es lo que se recorre en el html
            }
           /*  else if (objeto.type !== 'folder' && (objeto.key.indexOf('/') === -1 || (objeto.key.indexOf(this.fileManagerService.carpetaActual) !== -1))) {
                // Si el objeto es un fichero y no lleva / quiere decir que esta en el nivel raiz y entra aqui
                // Si el objeto es un fichero y su key lleva la carpeta actual tambien entra
                objeto.name = objeto.key.replace(this.fileManagerService.carpetaActual + '/', '');
                if (objeto.name !== '') {
                    this.ficheros.push(objeto);
                } // Guardo la carpeta dentro de ficheros, que es lo que se recorre en el html
            } */
            else {
                const partesNombre = objeto.key.split('/');
                objeto.name = partesNombre[partesNombre.length - 1];
                if (objeto.name !== '') {
                    this.ficheros.push(objeto);
                }
            }
        });
        this.dataSource = new MatTableDataSource(this.ficheros);

        // Indica de dónde sacar los datos para ordenar
        this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
                case 'name': return item.name.toLocaleLowerCase();
                case 'modified': return new Date(item.lastmodified);
                case 'size': return +item.size;
                /* case 'asociado': {
                    if (item.activoAsociado) {
                        return item.activoAsociado.nombre.toLocaleLowerCase();
                    }
                }
                    break; */
                default: return item[property];
            }
        };

        setTimeout(() => {
            this.dataSource.sort = this.sort;
        }, 500);

        this.qrValue = null;
        if (this.fileManagerService.carpetaActual != null) {
            this.canBack = true;
        }
        else {
            // Si estoy en el nivel raiz, será cuando necesite asociar activos y carpetas para mostrarlo
            this.asociarActivosACarpetas();
            // Nota: los activos tardan mas en cargar que los datos de amazon, asi que llamaré a este metodo en getActivos también
            // Buscar solucion a esto
        }
    }
    asociarActivosACarpetas() {
        // Cuando llega aqui, ya debe tener los activos y las carpetas
        // Este metodo es probablemente optimizable
        // Recorre los activos y los ficheros comprobando si estan asociados.
        // Si lo estan, meto el nombre del activo en la nueva propiedad activoAsociado del fichero
        // Esta propiedad la mostramos en la tabla
        if (this.activos && this.ficheros) {
            for (let i = 0; i < this.activos.length; i++) {
                this.ficheros.forEach(fichero => {
                    if (fichero.type === 'folder' && this.activos[i].carpetaAWS === fichero.name) {
                        fichero.activoAsociado = this.activos[i];
                    }
                });
            }
        }
    }
    descargarFichero(fichero: Fichero, version?) {
        if (fichero.type === 'folder') {
            // Voy a ir a otro nivel
            this.canBack = true;
            this.fileManagerService.carpetaActual = this.fileManagerService.carpetaActual ? this.fileManagerService.carpetaActual + '/' + fichero.name : fichero.name;
            this.showFiles();
        } else {
            this.fileManagerService.descargarFichero(fichero.key, version.VersionId);
        }
    }
    asociarTicket(fichero: Fichero, version?) {
        let activo: Activo;
        let activoId: number;
        if (fichero.type !== 'folder') {
            if (this.activos) {
                activo = this.getActivoOfCarpetaActual();
            } else {
                activoId = +localStorage.getItem('activoSeleccionadoId');
            }
            if (!activo && !activoId) {
                this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.FileManager.ActivoCarpetaNotFound);
            } else {
                const id = activo ? activo.id : activoId;
                this.ticketsService.getTicketFromActivo(id).subscribe(
                    data => {
                        if (data && data.success && data.items) {
                            this.instanciarModalTickets(data.items).subscribe(
                                (ticket: Ticket) => {
                                    if (ticket) {
                                        ticket.document_key = fichero.key;
                                        ticket.document_version = version.VersionId ? version.VersionId : version;
                                        this.ticketsService.updateTicket(ticket).subscribe(
                                            res => {
                                                if (res.success) {
                                                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Tickets.TicketEditado);
                                                }
                                                else {
                                                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Tickets.TicketNOEditado);
                                                }
                                            },
                                            err => {
                                                this.notificaciones.errorServidor(err.status);
                                            }
                                        );
                                    }
                                }
                            );
                        } else {
                            this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Tickets.SinTickets);
                        }
                    },
                    err => {
                        this.notificaciones.errorServidor(err.status);
                    }
                );
            }
        }
    }
    getActivoOfCarpetaActual(): Activo {
        try {
            let activoCarpeta;
            this.activos.forEach(activo => {
                if (this.fileManagerService.carpetaActual.split('/')[0] === activo.carpetaAWS) {
                    activoCarpeta = activo;
                }
            });
            return activoCarpeta;
        } catch (error) {
            console.log(error);
            return null;
        }
    }
    instanciarModalTickets(arrayTickets: Array<Ticket>): Observable<any> {
        let dialogRef: MatDialogRef<ListaModalComponent>;
        dialogRef = this.dialog.open(ListaModalComponent);
        dialogRef.updateSize('300px');
        dialogRef.componentInstance.title = 'LISTA_TICKETS';
        dialogRef.componentInstance.listaTickets = arrayTickets;
        return dialogRef.afterClosed();
    }
    getQr(fichero: Fichero, version) {
        this.reiniciarVariablesDeVisualizacion();
        if (fichero.type === 'pdf') {
            this.fileManagerService.getPdfQR(fichero, version).subscribe(
                data => {
                    const blob = new Blob([data], {
                        type: 'application/pdf'
                    });
                    const blobUrl = URL.createObjectURL(blob);

                    const iframe = document.createElement('iframe');
                    iframe.style.display = 'none';
                    iframe.src = blobUrl;
                    document.body.appendChild(iframe);
                    iframe.contentWindow.print();
                    // Lo grabo con el nombre que viene despues de la ultima barra. Ej: Carpeta/archivo.pdf => archivo.pdf
                    // const arraySt = fichero.key.split('/');
                    // saveAs(blob, arraySt[arraySt.length - 1]);

                },
                err => {
                    console.log(err);

                }
            );
        }

    }
    vistaPrevia(fichero: Fichero, version) {
        this.reiniciarVariablesDeVisualizacion();
        const component = this;
        if (fichero.type === 'pdf') {
            this.fileManagerService.getOptionToPrint(fichero.key, version.VersionId).send(
                function (err, data) {
                    if (err) {
                        console.log(err);
                        return;
                    }
                    const blob = new Blob([data.Body], {
                        type: 'application/pdf'
                    });
                    const blobUrl = URL.createObjectURL(blob);
                    // component.pdf = blobUrl;
                    // window.open(blobUrl);
                    component.pdfModalService.openModal(blobUrl);
                }
            );

        }
        else if (fichero.type === 'image') {
            this.fileManagerService.getOptionToPrint(fichero.key, version.VersionId).send(
                function (err, data) {
                    if (err) {
                        console.log(err);
                        return;
                    }
                    const blob = new Blob([data.Body], { type: '' });
                    const blobUrl = URL.createObjectURL(blob);
                    component.galleryImages = [
                        {
                            small: blobUrl,
                            medium: blobUrl,
                            big: blobUrl,
                            description: fichero.name
                        }
                    ];
                    component.galleryOptions =
                        [
                            {
                                'arrowPrevIcon': '',
                                'arrowNextIcon': '',
                                'thumbnails': false,
                                'thumbnailsArrows': false,
                                'thumbnailsMoveSize': 4,
                                'imageArrows': false,
                                'imageInfinityMove': true,
                                'imageAutoPlay': true,
                                'imageAutoPlayInterval': 5000,
                                'imageAutoPlayPauseOnHover': true,
                                'previewAutoPlay': false,
                                'previewInfinityMove': true,
                                'previewFullscreen': false,
                                'previewCloseOnClick': true,
                                'previewCloseOnEsc': true,
                                'previewZoom': true,
                                'previewRotate': true,
                                'width': '100%',
                                'height': '600px',
                                'imageSize': NgxGalleryImageSize.Contain,
                                'imageAnimation': NgxGalleryAnimation.Slide,
                                'thumbnailSize': NgxGalleryImageSize.Contain,
                                'previewDescription': true,
                                'imageDescription': true,
                                'imagePercent': 100,
                            },

                            {
                                'breakpoint': 500,
                                'height': '200px',
                                // 'thumbnailsColumns': 3
                            },

                            {
                                'breakpoint': 300,
                                'height': '100px',
                                // 'thumbnailsColumns': 2
                            },
                        ];
                    component.imagen = true;
                    // Se abre la galería
                    setTimeout(() => {
                        component.galeria.openPreview(0);
                    }, 0);

                }
            );
        }
    }
    encode(data) {
        const str = data.reduce(function (a, b) { return a + String.fromCharCode(b); }, '');
        return btoa(str).replace(/.{76}(?=.)/g, '$&\n');
    }
    abrirTicket(fichero: Fichero, version) {
        if (fichero.type !== 'folder') {
            // console.log(fichero);
            const rutaFichero = this.fileManagerService.carpetaActual.split('/');
            const codigoProyecto = rutaFichero[0];

            this.activosService.getActivoId(codigoProyecto).subscribe(
                data => {
                    if (data.success) {
                        const id = data.items;
                        this.ticketsService.setKey(fichero.key);
                        this.ticketsService.setVersion(version.VersionId);
                        this.router.navigate(['tickets/nuevo', id]);
                    }
                },
                err => console.log(err)
            );

        }
    }
    reiniciarVariablesDeVisualizacion() {
        this.pdf = null;
        this.imagen = false;
    }
    borrarFichero(fichero: Fichero, version?) {
        if (version) {
            fichero.versionElegida = version.VersionId;
        }
        const component = this;
        if (fichero.type === 'folder') {
            this.confirmService.confirm(
                this.notificaciones.mensajes.IdiomaActual.FileManager.BorrarCarpeta.Titulo,
                this.notificaciones.mensajes.IdiomaActual.FileManager.BorrarCarpeta.Mensaje)
                .subscribe(
                    result => {
                        if (result) {
                            // HABRA QUE PONER UN SPINNER QUE AMENICE LA ESPERA
                            this.fileManagerService.getFilesInCarpeta(fichero.key).send(function (err, data) {
                                // Cada data.Contents es un fichero (carpetas incluidas) a borrar
                                data.Contents.forEach(file => {
                                    const ficheroBorrar = new Fichero(file.Size, file.Key, file.ETag, file.LastModified, file.StorageClass, 'any');
                                    component.fileManagerService.deleteFile(ficheroBorrar).send(function (error) {
                                        if (error) {
                                            console.log('Fichero no borrado');

                                        }
                                    });
                                });
                                component.showFiles();
                            });
                        }
                    }
                );
        }
        else {
            this.confirmService.confirm(
                this.notificaciones.mensajes.IdiomaActual.FileManager.BorrarArchivo.Titulo,
                this.notificaciones.mensajes.IdiomaActual.FileManager.BorrarArchivo.Mensaje)
                .subscribe(
                    result => {
                        if (result) {
                            this.fileManagerService.deleteFile(fichero).send(function (err) {
                                if (!err) {
                                    if (component.ficheros.length === 1 && !version) {
                                        // Si solo tenia 1 archivo y lo borró sin especificar version, tengo que volver atras
                                        component.nivelAnterior();
                                    }
                                    else if (version && fichero.versions.length > 1) {
                                        // Si tiene varias versiones y ha borrado solo una
                                        fichero.versionElegida = null;
                                        component.showFiles();
                                    }
                                    else if (fichero.versions.length === 1) {
                                        // Solo le quedaba una version de ese archivo
                                        component.nivelAnterior();
                                    }
                                    else if (fichero.size === 0) {
                                        // Era una carpeta creada
                                        component.nivelAnterior();
                                    }
                                    else {
                                        // Si tenia mas archivos aparte del borrado pues actualizo
                                        component.showFiles();
                                    }
                                }
                            });
                        }
                    }
                );
        }
    }
    subirVersionFichero(ficheroOriginal, nuevo) {
        const component = this;
        this.fileManagerService.subirVersionFichero(ficheroOriginal, nuevo).send(
            function (err) {
                if (!err) {
                    component.showFiles();
                    component.notificaciones.mostrarAviso(component.notificaciones.mensajes.IdiomaActual.FileManager.VersionSubida);
                }
            }
        );
    }
    seleccionado(ficheroOriginal, event) {
        this.selectedFiles = event.target.files;
        this.subirVersionFichero(ficheroOriginal, this.selectedFiles.item(0));
    }
    getDetalle(fichero: Fichero) {
        const component = this;

        this.fileManagerService.getDetalle(fichero).send(
            function (err, data) {
                if (data.Versions) {
                    // component.qrValue = fichero.key;


                    // if (component.fileManagerService.carpetaActual + '/' !== fichero.key.split(fichero.name)[0]) {
                    //     // Aqui llega tras buscar el documento en el Dashboard

                    //     component.fileManagerService.carpetaActual = fichero.key.split('/' + fichero.name)[0]; // Le quito la barra que va en el ultimo caracter
                    //     component.showFiles();
                    // }
                    // else {
                    fichero.versions = new Array<any>();
                    fichero.versions = data.Versions;
                    // }
                    // data.Versions.forEach(version => {
                    //     fichero.versions.push(version);
                    // });
                }
                // Quiero que la ultima sea la mas alta asi que tengo que invertir el orden del array
                // Comento para mostrar de más a menos
                // fichero.versions.reverse();
                component.selected = fichero;
            }
        );
    }

    nivelAnterior() {
        if (this.fileManagerService.carpetaActual) {
            const niveles = this.fileManagerService.carpetaActual.split('/');
            this.fileManagerService.carpetaActual = ''; // Reinicio esta variable antes de asignarla
            for (let i = 0; i < niveles.length - 1; i++) {
                if (i === 0) {
                    // Para el primer nivel no pongo /, para el resto si
                    this.fileManagerService.carpetaActual = niveles[i];
                }
                else {
                    this.fileManagerService.carpetaActual += '/' + niveles[i];
                }
            }
            // Es importante que lo ponga a null si esta vacio y que cambie el canBack para no mostrar la flecha
            if (this.fileManagerService.carpetaActual === '') {
                this.fileManagerService.carpetaActual = null;
                this.canBack = false;
            }
        }
        // Cuando tengo el nuevo nivel configurado, muestro el arbol actual
        this.showFiles();
    }
    copiarAlPortapapeles(fichero: Fichero) {
        /*
        * El proceso para copiar consistirá en guardar de forma puntual el documento en this.ficheroACopiar
        * Después, se le muestra un mensaje al usuario para que se desplace a la carpeta donde quiere copiarlo
        * Una vez en la carpeta, pulsará un botón de "COPIAR AQUI" (o similar) y se llamará al metodo de copia del filemanager.service
        * Este metodo necesita la carpeta de destino (this.fileManagerService.carpetaActual) + el nombre del archivo
        */
        this.ficheroACopiar = fichero;
        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.FileManager.InicioCopia);
    }
    copiarAqui() {
        const component = this;
        if (this.fileManagerService.carpetaActual == null) {
            // En la raiz no se puede copiar
            this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.FileManager.CopiaEnRaizNoPermitida);
        }
        else if (this.ficheroACopiar.key === this.fileManagerService.carpetaActual + '/' + this.ficheroACopiar.name) {
            // En la misma carpeta no se puede copiar
            this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.FileManager.CopiaEnMismaCarpeta);

        }
        else {
            this.fileManagerService.copyObject(this.ficheroACopiar, this.fileManagerService.carpetaActual).send(
                function (err) {
                    if (!err) {
                        component.ficheroACopiar = null;
                        component.showFiles();
                    }
                    else {
                        console.log(err);
                    }
                }
            );
        }
    }

    // Para resaltar fila seleccionada
    onSelect(selected) {
        this.selected = selected;
    }

    getActivos() {
        this.activosService.getActivosDatosBasicos().subscribe(
            data => {
                if (data.success) {
                    this.activos = data.items;
                    // Solucion provisional al problema de que Amazon traiga los datos antes como se explica en generarRama()
                    this.asociarActivosACarpetas();
                } else {
                    // CONTROLAR ERROR
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.SinActivos);
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
            }
        );

    }
    asociarActivo(file: Fichero, activo: Activo) {
        if (file.activoAsociado) {
            // Si ya tenia un activo asociado, primero borro la referencia a la carpeta en dicho activo, para que no de error cuando el campo carpetaAWS sea unico
            // TODO
            file.activoAsociado.carpetaAWS = 'Esto seria null';
            this.activosService.updateActivo(file.activoAsociado).subscribe(
                data => {
                    if (data.success) {
                        activo.carpetaAWS = file.name;
                        this.actualizarActivo(activo);
                    }
                    else {
                        this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.ActivoNOEditado);
                        this.asociar = false;
                        activo = null;
                    }
                },
                err => {
                    this.notificaciones.errorServidor(err.status);
                    this.asociar = false;
                    activo = null;
                }
            );
        }
        else {
            // La carpeta no tenia ningun activo ya asociado y se puede completar el proceso de forma natural
            activo.carpetaAWS = file.name;
            this.actualizarActivo(activo);
        }
    }
    actualizarActivo(activo: Activo) {
        // Recibe el activo cuyo campo CarpetaAWS ha sido editado y completa el proceso del metodo asociarActivo
        this.activosService.updateActivo(activo).subscribe(
            data => {
                if (data.success) {
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.ActivoEditado);
                    this.asociar = false;
                    activo = null;
                    // Lo asocio así también para que se refleje en la tabla
                    this.showFiles();
                }
                else {
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Activos.ActivoNOEditado);
                    this.asociar = false;
                    activo = null;
                }
            },
            err => {
                this.notificaciones.errorServidor(err.status);
                this.asociar = false;
                activo = null;
            }
        );

    }
    estaEnRaiz(): boolean {
        // Metodo para ocultar la flecha cuando esta en el nivel raiz
        if (this.fileManagerService.carpetaActual) {
            return false;
        } else {
            return true;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/file-manager/file-list/file-list.component.ts